import { SyntheticEvent } from 'react';
import { InfoCircleFill } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { Button } from 'antd';

import Alert from '@/components/shared/Alert';
import { useAppSelector } from '@/hooks/redux';
import { useUpsell } from '@/hooks/useUpsell';
import { blockedStatus, enStatus, ICourse } from '@/interfaces/course';
import { IResult } from '@/interfaces/query';
import { loginAccounts } from '@/services/accounts';
import { coursesApi, useRegisterMutation } from '@/services/course';
import styled, { StyledProp } from '@/styled';

const NotPurchased = ({ className }: StyledProp) => {
  const { hash } = useParams<{ hash: string }>();
  const [register, { isLoading }] = useRegisterMutation();
  const user = useAppSelector(store => store.auth.user);

  const { data: course } = coursesApi.endpoints.getCourse.useQueryState<IResult<ICourse>>(hash, { skip: !hash });
  const openUpsell = useUpsell(
    {
      id: 0,
      producer_id: course?.producer?.id,
      type: 0,
      show_type: 1,
      content: String(course?.offer),
      description: course?.description,
      title: course?.title
    },
    { utm_medium: 'curso' }
  );

  if (course?.blocked_by !== enStatus.NOT_PURCHASED) {
    return null;
  }

  const isBlocked = [...blockedStatus, enStatus.SOMETHING_FREE].includes(course?.status);
  const showOffer = Boolean(course?.offer) || course?.access_type === 2;

  if (!isBlocked || !showOffer) {
    return null;
  }

  const purchase = (event: SyntheticEvent) => {
    if (!user?.email && course.is_free) {
      loginAccounts();
      return;
    }

    if (course.is_free && !!user.email) {
      register(hash);
      return;
    }

    openUpsell(event);
  };

  return (
    <Alert
      className={className}
      icon={<InfoCircleFill size={20} />}
      type='error'
      message={'Parece que você não tem acesso a esse curso.'}
      id='alert-access'
      description={`Adquira ele agora${course?.is_free ? ' gratuitamente!' : '!'}`}
      action={
        <Button
          loading={isLoading}
          type='primary'
          rootClassName='button'
          size='large'
          onClick={purchase}
          id='btn-acquire'
        >
          Adquirir curso
        </Button>
      }
    />
  );
};

export default styled(NotPurchased)`
  .button {
    svg {
      color: ${({ theme }) => theme.colorIcon};
    }
  }
`;
